/*
 * Copyright (c) 2026. Tooling Team
 */

// Utility functions for authorization and user access management

export function isAdminUser() {
  return window.sessionStorage.getItem("isAdmin") === "true";
}

export function setAdminUserAccess(isAdmin) {
  window.sessionStorage.setItem("isAdmin", `${isAdmin === true}`);
}

//hide WIP Lab Domain card on the Home Page for stg and prod environments (temporary fix)
export function isLabDomainHiddenForUrl(url) {
  if (typeof url !== "string") {
    return false;
  }

  try {
    const parsedUrl = new URL(url);
    const host = parsedUrl.hostname.toLowerCase();
    return (
      parsedUrl.protocol === "https:" &&
      (host === "cmt" ||
        host === "stg.cmt" ||
        host.startsWith("cmt.") ||
        host.startsWith("stg.cmt."))
    );
  } catch {
    return false;
  }
}
